var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"six-banner"},[_c('div',{staticClass:"banner-text"},[_c('h1',{staticClass:"bold"},[_vm._v(_vm._s(_vm.title))]),_c('h4',{staticClass:"medium"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }